module.exports = "./img/6f625bfae83c35ad573bdfa5b524d33b.jpg";